export const MinLengthTypeAhead = 2;

export const UrlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\s%\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

export const AlhpaNumericAndDashAndSpaceRegex = /^[a-zA-Z0-9- ]+$/;
